<template>
<div class="form-group" :class="[{ 'coff-input-error' : error }]" :key="uuid">

    <label htmlFor="input">
        <b>{{$t(label)}}</b>
        <slot name="label"></slot>
    </label>

    <div class="input-group coff-input-color-group">
        <ColorPicker :class="[{ 'p-error' : error }]" :value="hexValue" @input="onInput" :id="uuid" :disabled="disable"/>
        <span class="coff-input-color-value">{{ value || '' }}</span>
        <span v-if="error">{{ $t(errorMessage)}}</span>
    </div>

</div>
</template>

<script>
    import Utils from "@/utils/Utils";

    export default {
        name: "CoffInputColor",

        props:{
            label: {type: String, default: null},
            value: null,
            error: {type: Boolean, default: false},
            errorMessage: {type: String, default: 'field.default.error'},
            id: null,
            disable: {type: Boolean, default: false},
        },

        data(){
            return {
                uuid: Utils.uuid(),
            }
        },

        mounted() {
            if(this.id){
                this.uuid = this.id;
            }
        },

        computed: {
            hexValue() {
                return (this.value || '').replace('#', '');
            },
        },

        methods: {
            onInput(newValue){
                this.$emit('input', `#${newValue}`.toUpperCase());
            },
        },
    }
</script>

<style scoped>

    .coff-input-color-group {
        display: flex;
        align-items: center;
        gap: 0.5rem;
    }

</style>
